import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: '#18191D',
		marginTop: 20,
		border: '1px solid #18191D',
	},
	integrationTitle: {
		color: '#18191D',
	},
});
